// Distinct action types (SCRUM-882): several domain slices already define a
// bare `CLEAR_MESSAGE = "CLEAR_MESSAGE"`, so this channel uses its own names to
// avoid colliding with them.
export const SET_APP_MESSAGE = "SET_APP_MESSAGE";
export const CLEAR_APP_MESSAGE = "CLEAR_APP_MESSAGE";
